export default __webpack_public_path__ + "static/media/arrow-right.14ba0c3e.svg";